import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const EditorContentModeButton: LoadableType<{
	contentId: string;
	disabled?: boolean;
	isStatusDisconnected?: boolean;
}> = LoadableAfterPaint({
	loader: async () => {
		const { EditorContentModeButton } = await import(
			/* webpackChunkName: "loadable-EditorContentModeButton" */ '../src/components/EditorContentModeButton.tsx'
		);
		return EditorContentModeButton;
	},
});
